import { LoginFormCard } from "./LoginFormCard";

const APP_VERSION = process.env.REACT_APP_VERSION;
const GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

export function Login() {
  return (
    <div className="flex flex-column justify-content-between h-screen" style={{
      backgroundImage: "url('/images/image-background.svg')",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    }}>
      <div className="flex flex-grow-1 justify-content-center align-items-start p-4 mb-8" style={{ marginTop: "100px" }}>
        <LoginFormCard showBackButton />
      </div>
      <div className="px-3 pb-2">
        <span className="text-xs text-500">{APP_VERSION} ({GIT_COMMIT} - {ENVIRONMENT})</span>
      </div>
    </div>
  );
}